import { ContentFilters, ContentTopBar } from 'components';
import { useState } from 'react';
import { CompanyType } from 'types';

import { LoadingFilterForm } from './loading-filter-form';
import { LoadingFilterFormValues } from './type';
type MatrialTopBarProps = {
  getInitialFilterValues: LoadingFilterFormValues;
  handleFilter: (values: LoadingFilterFormValues) => void;
  userEditData: any;
  showAppUserModal:any;
  setShowAppUserModal:any;
  onRefresh: () => void;
};

export const LoadingLogViewTopBar = ({
  getInitialFilterValues,
  handleFilter,
  onRefresh
}: MatrialTopBarProps) => {
  useState<CompanyType>();
  const formId = 'end-users-filters-form';
  
return (
    <>
      <ContentTopBar title={'Loading Logs'}/>
      <ContentFilters formId={formId}>
        <LoadingFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={getInitialFilterValues}
          onRefresh={onRefresh}
        />
      </ContentFilters>
    </>
  );
};
